import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLegend,
  FieldSeparator,
  FieldSet,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";

import { PositionFields } from "../../components/PositionFields";
import { mapFormOptions } from "../shared";

export const PositionBlock = withForm({
  ...mapFormOptions,
  render: function Render({ form }) {
    return (
      <FieldSet>
        <FieldLegend>Default Map Position</FieldLegend>
        <FieldDescription>
          Set the default map position and zoom shown when the map first loads.
        </FieldDescription>

        <FieldGroup>
          <Field className="max-w-32">
            <form.AppField name="zoom">
              {(field) => (
                <field.NumberSelectField
                  label="Default zoom"
                  max={20}
                  min={2}
                  step={1}
                />
              )}
            </form.AppField>
          </Field>
          <FieldSeparator />
          <Field>
            <PositionFields form={form} fields="position" />
          </Field>
        </FieldGroup>
      </FieldSet>
    );
  },
});
